/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneTiktok as ResolvedStandaloneTiktok } from 'base/components/standalone/Tiktok';

export const Tiktok: typeof ResolvedStandaloneTiktok = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneTiktok {...props} />
        </ErrorBoundary>
    );
});

export type TiktokProps = PropsFromComponent<typeof Tiktok>;

/** @deprecated Use slot architecture instead */
export const TiktokWith = (extras: DynamicStandaloneExtras): typeof Tiktok => {
    return function Tiktok(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Tiktok');
        return <ResolvedStandaloneTiktok {...mergeProps({ options: { theme } }, props)} />;
    }
}